<template>
  <div>
    <div class="d-flex justify-content-center title mt-3">What Do People Say About Us?</div>

    <ClientOnly>
      <swiper :modules="modules" navigation :pagination="{ clickable: true }" class="visuals mt-3">
        <swiper-slide v-for="(image, index) in allImages" :key="`vis-${index}`"
          ><img v-image :src="image"
        /></swiper-slide>
        ...
      </swiper>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Navigation, Pagination } from 'swiper';

@Options({
  name: 'SocialProof',
})
export default class SocialProof extends Vue {
  public allImages = [
    'https://cdn.characterhub.com/users/8f39523a-34e2-463c-ae19-1f831aa19011/da3a17cf-f4ed-4a66-8651-4344bfd060b4_l',
    'https://cdn.characterhub.com/users/8f39523a-34e2-463c-ae19-1f831aa19011/1e4ef8f6-5097-48dd-8836-507a7508c865_l',
    'https://cdn.characterhub.com/users/8f39523a-34e2-463c-ae19-1f831aa19011/a1e8ac48-7b6b-4945-883d-5759cee88db0_l',
    'https://cdn.characterhub.com/users/8f39523a-34e2-463c-ae19-1f831aa19011/9ee691a9-468c-4700-ba65-d3b1d6ce7157_l',
    'https://cdn.characterhub.com/users/8f39523a-34e2-463c-ae19-1f831aa19011/db100fca-ba9d-43a6-a9de-852da51456c3_l',
    '/social-media-proof.png',
  ];

  public modules = [
    Navigation, Pagination
  ]

  public slideOptions = {
    initialSlide: 1,
    speed: 400,
  };

  setup() {
    const slideOpts = {
      initialSlide: 1,
      speed: 400,
    };
    return { slideOpts };
  }
}
</script>
<style lang="sass" scoped>
.title
  font-size: 24px
  font-weight: bold
.visuals
  height: 200px
  @media (max-width: 480px)
    height: 100px
</style>
